const React = require('react');

const { Title } = require('@andes/typography');

const ButtonBackURLs = require('../../../../components/ButtonBackURLs');
const CardListGuestSection = require('../components/CardListGuestSection');
const PaymentOptionPropTypes = require('../templatePropTypes');
const Page = require('../../../../components/Page');
const PaidWithCashSection = require('../components/PaidWithCashSection');
const Optimus = require('../../../../containers/Optimus');
const useHeightElement = require('../../../../hooks/useHeightElement');
const Footer = require('@cow/core-components/components/Footer');
const classNames = require('classnames');
const PaymentSummaryMobile = require('@cow/core-components/components/PaymentSummaryMobile');
const Brand = require('@cow/core-components/components/Brand');
const GenericModal = require('@cow/core-components/components/GenericModal');
const translate = require('../../../../translation');
const { isMobile } = require('../../../../utils/webview');
const {
  handleSummaryItemProps,
  isCollapsible,
  getMobileTotal,
  PAYMENT_SUMMARY_ALIGNMENT,
  hasBrand,
} = require('../../../../utils/summary');
const { useControlSummary } = require('../../../../hooks/useNavbar');

const {
  COMMONS: {
    CHECKOUT_CASE: { 
      SUBSCRIPTION, 
      PAYMENT 
    },
  },
  SELECTORS,
} = require('../../../../../constants');

const PaymentOptionsMobileGuest = (props) => {
  const translations = translate(props.i18n);
  const paddingContent = useHeightElement();
  const { isOpenedSummary, handleCollapsedSummary } = useControlSummary();

  const tooltipContainer = React.createRef();
  const [showDiscountModal, setShowDiscountModal] = React.useState(false);

  const { summary, summaryFromComponents } = props.frontendData;
  const summaryItems = summary?.items ?? [];
  const brand = props.frontendData.brand;

  let isPaymentSummaryCollapsible = isCollapsible(
    summaryItems?.length,
    props.frontendData.transaction_type,
    summary,
  );

  if (!isPaymentSummaryCollapsible && summaryItems?.length > 1) {
    isPaymentSummaryCollapsible = true;
  }

  return (
    <Page
      title={props.frontendData.pageTitle}
      currentStep={props.currentStep}
      urls={props.urls}
      trackingPath={props.trackingPath}
      analytics={props.analytics}
      deviceType={props.deviceType}
    >
      <section className="payment-options-mobile-screen payment-options-mobile-screen--guest">
        {summary ? (
          <>
            {hasBrand(brand) && (
              <Brand
                image={brand.avatar}
                name={brand.name}
                isMobile={isMobile(props.deviceType)}
                isUserLogged={props.userLogged}
                withNavbar={false}
              />
            )}

            <PaymentSummaryMobile
              isUserLogged={props.userLogged}
              title={summary?.title}
              isCollapsible={isPaymentSummaryCollapsible}
              items={
                isPaymentSummaryCollapsible &&
                summaryItems?.map((item) =>
                  handleSummaryItemProps({
                    item,
                    summary,
                    showTaxes: props.frontendData.showTaxes,
                    translations,
                    tooltipContainer,
                    setShowDiscountModal,
                    deviceType: props.deviceType,
                    iconAlignment: isPaymentSummaryCollapsible
                      ? PAYMENT_SUMMARY_ALIGNMENT.LEFT
                      : PAYMENT_SUMMARY_ALIGNMENT.RIGHT,
                  }),
                )?.filter((item) => item)
              }
              total={getMobileTotal(
                summary,
                PAYMENT,
                null,
                null,
              )}
              withNavbar={false}
              autoHeightClassname={props.frontendData.transaction_type === SUBSCRIPTION ? 'auto-height' : ''}
              brand={hasBrand(brand)}
              open={isOpenedSummary}
              onCollapsed={handleCollapsedSummary}
            />
          </>
        ) : (
          <Optimus
            components={summaryFromComponents}
            history={props.history}
            siteId={props.siteId}
            urls={props.urls}
            publicKey={props.publicKey}
            deviceType={props.deviceType}
            captcha={props.captcha}
            hiddenComponents={props.hidden_components}
          />
        )}

        <div className="payment-options-mobile-screen__content" style={{ paddingTop: paddingContent }}>
          <Title component="h1" size="s" className="payment-options-mobile-screen__content-title">
            {props.frontendData.pageTitle}
          </Title>

          <div
            className={classNames('payment-options-mobile-screen__content-card-list', {
              [SELECTORS.REBRANDING]: props.configs?.rebrandingMP,
            })}
          >
            {!props.frontendData.showPayWithCashScreen && (
              <CardListGuestSection
                otherPaymentMethods={props.frontendData.otherPaymentMethods}
                goToScreen={props.frontendData.goToScreen}
                loginSection={props.frontendData.loginSection}
                guestSection={props.frontendData.guestSection}
                deviceType={props.deviceType}
                showPayWithCashSection={props.frontendData.showPayWithCash}
                isTheOptionToPayWithCash={props.frontendData.isTheOptionToPayWithCash}
              />
            )}

            {props.frontendData.showPayWithCashScreen && (
              <PaidWithCashSection
                {...props.frontendData.payWithCash[props.frontendData.showPayWithCashScreen]}
                deviceType={props.deviceType}
                onClickMethod={props.frontendData.goToStorePage}
                onNavigationBack={props.frontendData.hidePayWithCash}
              />
            )}
            {/* TODO USE BACK BUTTON FROM LIBRARY COMPONENT */}
            {props.frontendData.discount?.is_applicable && (
              <GenericModal
                className="discount-modal"
                title={translations.GENERAL_CONDITIONS}
                content={<>{props.frontendData.discount?.detail}</>}
                isOpen={showDiscountModal}
                deviceType={props.deviceType}
                onClose={() => setShowDiscountModal(false)}
                onOpen={() => setShowDiscountModal(true)}
              />
            )}

            {props.frontendData.backButton && (
              <ButtonBackURLs label={props.frontendData.backButton?.title} url={props.frontendData.backButton?.url} />
            )}
          </div>
          {
            !props.frontendData.showPayWithCashScreen &&
            <div className="payment-options-mobile-screen__content-footer">
              <Footer
                requiredMessage={props.frontendData.footer.requiredMessage}
                requiredScreenReaderMessage={props.frontendData.footer.requiredScreenReaderMessage}
                deviceType={props.deviceType}
              />
            </div>
          }
        </div>
      </section>
    </Page>
  );
};

PaymentOptionsMobileGuest.propTypes = PaymentOptionPropTypes;

module.exports = PaymentOptionsMobileGuest;
